import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Widget from './Widget'

export default class SearchWidget extends Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onErrorCode: PropTypes.func,
    searchId: PropTypes.number,
    applyAgent: PropTypes.bool,
    advanced: PropTypes.bool,
  }

  static defaultProps = {
    onChange: x => x,
    onErrorCode: x => x,
    advanced: true,
  }

  componentDidMount() {
    window.addEventListener("message", this.recievePostMessage)
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.recievePostMessage)
  }

  recievePostMessage = event => {
    const { data } = event
    if (!data || !this.isFromThisWidget(event)) {
      return
    }
    if (data.type === 'SIDX_PARAMETERIZED_SEARCH_FILTERS') {
      this.props.onChange(data.payload)
    }

    if (data.type === 'SIDX_NEXT_REDUX_STATE') {
      const { searchResults } = data.payload || {}
      this.props.onErrorCode((searchResults && searchResults.errorCode) || null)
    }
  }

  // Messages carry no widget id, so match on our own iframe. Fall back to
  // accepting when the content window can't be resolved.
  isFromThisWidget(event) {
    const contentWindow = this.widget && this.widget.getContentWindow()
    if (!contentWindow || !event.source) {
      return true
    }
    return event.source === contentWindow
  }

  render() {
    let params, src = 'searchform?show=map&show=live&show=pills&hide=submit'

    src = `${src}&website_uuid=${this.props.website_uuid}`

    if (this.props.searchId) {
      src = `${src}&search_id=${this.props.searchId}`
    } else if (this.props.searchTemplateId) {
      src = `${src}&search_template_id=${this.props.searchTemplateId}`
    }

    if (this.props.advanced) {
      src = `${src}&show=advanced`
    }

    if (this.props.applyAgent) {
      src = `${src}&apply_agent_search=yes`
    }

    if ('streamlined' in this.props) {
      src = `${src}&streamlined=${this.props.streamlined}`
    }

    if (this.props.initialBounds) {
      src = `${src}&initial_bounds=${this.props.initialBounds}`
    }

    if (this.props.params) {
      params = {
        initial_search_filters: JSON.stringify(this.props.params)
      }
    }

    return (
      <Widget ref={el => this.widget = el} src={src} params={params} width="100%" dynamicHeight />
    )
  }
}



// WEBPACK FOOTER //
// client/components/SearchWidget.js